import React, { PureComponent } from "react";
import Banner from "./Banner";
import BannerBottomSteps from "./BannerBottomSteps";
import CheckoutMain from "./CheckoutMain";
import AnyQuestions from "../../reusable/AnyQuestions";
import StayTouch from "../../layout/StayTouch";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import { PulseLoader } from "react-spinners";
import Validator from "validator";
import { withRouter, Router } from "react-router-dom";

import {addToCart, getCart} from "../../modules/actions/cartActions";

import {
  placePaypalOrder,
  clearOrderResult
} from "../../modules/actions/orderActions";
import NotificationAlert from "react-notification-alert";
import {
  geCurrentUser,
  updateShipping,
  updateBilling
} from "../../modules/actions/authActions";
import { addFlashMessage } from "../../modules/actions/flashMessages.js";
import qs from "qs";
const uuidv4 = require("uuid/v4");

function validateAddress(data) {
  let errors = {};
  if (Validator.isEmpty(data.firstname)) {
    errors.firstname = "This field is required";
  }

  if (Validator.isEmpty(data.lastname)) {
    errors.lastname = "This field is required";
  }

  if (Validator.isEmpty(data.address1)) {
    errors.address1 = "This field is required";
  }

  if (Validator.isEmpty(data.city)) {
    errors.city = "This field is required";
  }
  if (Validator.isEmpty(data.state)) {
    errors.state = "This field is required";
  }
  if (Validator.isEmpty(data.country)) {
    errors.country = "This field is required";
  }
  if (Validator.isEmpty(data.zipcode)) {
    errors.zipcode = "This field is required";
  }
  return {
    errors,
    isValid: isEmpty(errors)
  };
}

class ESimCheckout extends PureComponent {

  step = 0;
  referenceStep = 0;

  recaptchaRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      ...this.props.state,
      step2: true,
      isProcessing: false,
      isHuman: false,
      humanKey: null
    };

    this.props = {...this.props.props};

    console.log("ESim contructorProps", this.props);
  }

  isValidAddress(address) {
    const { errors, isValid } = validateAddress(address);
    if (!isValid) {
      this.setState({ errors });
    }
    return isValid;
  }


  getQueryParams(){
    const qsParsed = qs.parse(
        this.context.router.history.location.search.slice(1)
    );
    return !!qsParsed.login;
  }

  refetch = () => {
    let payload = {
      sessionId: localStorage.getItem("sessionId")
    };
    this.props.getCart(payload);
    this.props.geCurrentUser();
  };

  handleBilling = billing => {
    billing.cartId = this.props.cart.cart;
    this.props.updateBilling(billing).then(data => {
      if (data.status) {
        this.setState({ billing });
        this.onStep4();
      }
    });
  };

  calculateTax = () => {
    let tax = 0;
    if (this.state.billing.state === "NJ") {
      tax = (this.props.cart.cart.subtotal / 100) * 6.625;
    }
    return tax.toFixed(2);
  };


  componentWillReceiveProps(nextProps) {
    console.log("ESimComponent NewProps", nextProps);
    if (typeof nextProps.state.orderPayload.orderId !== "undefined") {
      console.log("ESimComponent NewProps OrderID", nextProps.state.orderPayload.orderId);
      console.log("calling in recieve props order payload", nextProps.state.orderPayload);
      this.setState({ orderPayload: {...nextProps.state.orderPayload} });
      this.onStep5();
    }
  }

  isAddressFilled = () => {
    if (!this.isValidAddress(this.state.billing)) {
      this.refs.notify.notificationAlert({
        place: "tc",
        message: (
            <div>
              <div>
                <b>Please Enter your Billing info</b>
              </div>
            </div>
        ),
        type: "danger",
        icon: "now-ui-icons ui-1_bell-53",
        autoDismiss: 7
      });
      this.onStep2();
      return false;
    }
    return true;
  };

  handlePaypalPayment = paypal => {
    if(!this.state.isProcessing) {
      this.state.isProcessing = true;
      if (this.isAddressFilled()) {
        const orderPayload = {
          billing: this.state.billing,
          paypal: paypal,
          phone_no: (typeof this.props.cart.cart.phone_no !== "undefined") ? this.props.cart.cart.phone_no : "",
          imei: (typeof this.props.cart.cart.imei !== "undefined") ? this.props.cart.cart.imei : "",
          cart: this.props.cart.cart,
          easyReturn: this.state.easyReturn,
          paymentmode: "paypal",
          after_discount_totals_flat: (typeof this.props.apply_discount.flatTotal !== "undefined" && this.props.apply_discount.flatTotal !== null && this.props.apply_discount.flatTotal !== null && typeof this.props.apply_discount.flatTotal.grandTotal !== "undefined") ? this.props.apply_discount.flatTotal : null,
          after_discount_totals: (typeof this.props.apply_discount.totals !== "undefined" && this.props.apply_discount.totals !== null && this.props.apply_discount.totals !== null && this.props.apply_discount.totals.length > 0) ? this.props.apply_discount.totals : null
        };
        this.props
            .placePaypalOrder(orderPayload)
            .then(data => {
              this.state.isProcessing = false;
            })
            .catch(error => {
              this.refs.notify.notificationAlert({
                place: "tc",
                message: (
                    <div>
                      <div>
                        <b>{error.response.data.message}</b>
                      </div>
                    </div>
                ),
                type: "danger",
                icon: "now-ui-icons ui-1_bell-53",
                autoDismiss: 7
              });
              this.state.isProcessing = false;
            });
      } else {
        this.state.isProcessing = false;
      }
    }
  };

  handlePayment = payment => {
    if(!this.state.isProcessing) {
      this.state.isProcessing = true;
      if (this.isAddressFilled()) {
        this.setState({payment, errors: {}, isLoading: true});
        const orderPayload = {
          billing: this.state.billing,
          payment: payment,
          phone_no: (typeof this.props.cart.cart.phone_no !== "undefined") ? this.props.cart.cart.phone_no : "",
          cart: this.props.cart.cart,
          easyReturn: this.state.easyReturn,
          paymentmode: this.state.paymentmode,
          after_discount_totals_flat: (typeof this.props.apply_discount.flatTotal !== "undefined" && this.props.apply_discount.flatTotal !== null && this.props.apply_discount.flatTotal !== null && typeof this.props.apply_discount.flatTotal.grandTotal !== "undefined") ? this.props.apply_discount.flatTotal : null,
          after_discount_totals: (typeof this.props.apply_discount.totals !== "undefined" && this.props.apply_discount.totals !== null && this.props.apply_discount.totals !== null && this.props.apply_discount.totals.length > 0) ? this.props.apply_discount.totals : null,
          humanKey: this.state.humanKey
        };

        this.props
            .placeOrder(orderPayload)
            .then(data => {
              this.state.isProcessing = false;
              this.setState({isLoading: false});
            })
            .catch(error => {
              this.refs.notify.notificationAlert({
                place: "bl",
                message: (
                    <div>
                      <div>
                        <b>{error.response.data.message}</b>
                      </div>
                    </div>
                ),
                type: "danger",
                icon: "now-ui-icons ui-1_bell-53",
                autoDismiss: 7
              });
              this.state.isProcessing = false;
              this.setState({isLoading: false});

              this.recaptchaRef.current.reset();
              this.setState({isHuman: false, humanKey: null});
            });
      } else {
        this.state.isProcessing = false;
      }
    }
  };

  setpaymentMode = mode => {
    this.setState({
      paymentmode: mode
    });
  };

  onStepStart = () => {
    this.refetch();
    this.setState({
      step1: false,
      step2: true,
      step3: false,
      step4: false,
      step5: false,
      isProcessing: false
    });
    this.context.router.history.goBack()
  };

  // onStep1 = () => {
  //   this.refetch();
  //   this.setState({
  //     step1: true,
  //     step2: false,
  //     step3: false,
  //     step4: false,
  //     step5: false
  //   });
  //   this.step = 1;
  // };

  onStep2 = () => {
    this.refetch();
    this.setState({
      step1: false,
      step2: true,
      step3: false,
      step4: false,
      step5: false,
      isProcessing: false
    });
    this.step = 2;
  };

  // onStep3 = () => {
  //   this.refetch();
  //   this.setState({
  //     step1: false,
  //     step2: false,
  //     step3: true,
  //     step4: false,
  //     step5: false
  //   });
  //   this.step = 3;
  // };
  onStep4 = () => {
    this.refetch();
    this.setState({
      step1: false,
      step2: false,
      step3: false,
      step4: true,
      step5: false,
      isProcessing: false
    });
    this.step = 4;
  };

  onStep5 = () => {
    this.setState({
      step1: false,
      step2: false,
      step3: false,
      step4: false,
      step5: true,
      isProcessing: false
    });
    this.step = 5;
  };

  breadcrumbActive = (step) =>{
    if (this.step > this.referenceStep){
      this.referenceStep = this.step;
    }
    /*console.log("referenceStep: ", this.referenceStep);
    console.log("requestedStep: ", step);
    console.log("completedStep: ", this.step);*/
    if (this.referenceStep != 5 && (step < this.step || step <= this.referenceStep)) {
      switch (step) {
        case 1:
          this.onStep1();
          break;
        case 2:
          this.onStep2();
          break;
        case 3:
          this.onStep3();
          break;
        case 4:
          this.onStep4();
          break;
        case 5:
          this.onStep5();
          break;
      }
    }
  };

  // ReCAPTCHA Client Side
  verifyCaptcha = (res) => {
    if(res) {
      this.setState({ isHuman: true, humanKey: res })
    }
  }

  // ReCAPTCHA Expired
  expireCaptcha = () => {
    this.setState({ isHuman: false, humanKey: null })
  }

  render() {
    console.log("ESimCheckout");
    return (
        <div>
          <PulseLoader
              className="sweet-loading"
              sizeUnit={"px"}
              size={20}
              color={"#123abc"}
              loading={this.state.isLoading}
          />
          <NotificationAlert ref="notify" />
          <Banner status={this.state} />
          <BannerBottomSteps
              status={this.state}
              step1={this.onStep1}
              step2={this.onStep2}
              step3={this.onStep3}
              step4={this.onStep4}
              breadcrumbActive={this.breadcrumbActive}
          />
          <CheckoutMain
              data={this.state}
              router={this.props.props.location.params}
              product={{...this.props.props.cart.cart.product}}
              cart={this.props.props.cart.cart}
              backStep1={this.onStepStart}
              backStep3={this.onStep2}
              handleBilling={this.handleBilling}
              handlePayment={this.handlePayment}
              apply_discount={this.props.apply_discount}
              handlePaypalPayment={this.handlePaypalPayment}
              orderPayload={this.state.orderPayload}
              setpaymentMode={this.setpaymentMode}
              calculateTax={this.calculateTax}
              isAddressFilled={this.isAddressFilled}
              isProcessing={this.state.isProcessing}
              auth={this.props.props.auth}
              validateDiscount = {this.props.validateDiscount}
              setDiscountCode = {this.props.setDiscountCode}
              validate_discount_error = {this.props.validate_discount_error}
              recaptchaRef={this.recaptchaRef}
              isHuman={this.state.isHuman}
              humanKey={this.state.humanKey}
              verifyCaptcha={this.verifyCaptcha}
              expireCaptcha={this.expireCaptcha}
          />
          <AnyQuestions />
          <StayTouch />
        </div>
    );
  }
}

ESimCheckout.contextTypes = {
  router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
    cart: state.cart,
    order: state.order,
    redirectUrl: state.order.redirectUrl
  };
}

export default withRouter(connect(
    mapStateToProps,
    {
      addToCart,
      getCart,
      addFlashMessage,
      geCurrentUser,
      updateShipping,
      updateBilling,
      placePaypalOrder,
      clearOrderResult
    }
)(layoutWrapper(ESimCheckout)));



// WEBPACK FOOTER //
// ./src/pages/eSimCheckout/index.js